var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('update-features'),_c('nav-vertical',{scopedSlots:_vm._u([{key:"nav_bottom",fn:function(){return [_c('btn-version-estable')]},proxy:true}])}),_c('tasks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }